import { render, staticRenderFns } from "./Moldeo.vue?vue&type=template&id=6dfc3208"
import script from "./Moldeo.vue?vue&type=script&lang=js"
export * from "./Moldeo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports